import clsx from 'clsx'
import { FC } from 'react'
import { MdChevronRight } from 'react-icons/md'
import Select, {
  ClearIndicatorProps,
  components,
  DropdownIndicatorProps,
  GroupBase,
  IndicatorSeparatorProps,
  OptionProps,
  StylesConfig,
} from 'react-select'

export type FilterDropdownOption = {
  label: string
  value: string
  count?: number
  disabled?: boolean | false
}

type FilterDropdownProps = {
  placeholder: string
  options: FilterDropdownOption[]
  selectedOptions: FilterDropdownOption[]
  onChange: (options: FilterDropdownOption[]) => void
}

const FilterDropdown: FC<FilterDropdownProps> = ({
  options,
  placeholder,
  onChange,
  selectedOptions,
}) => {
  return (
    <Select
      instanceId={'filterDropdown'}
      className="categorySelect"
      isMulti
      options={options}
      controlShouldRenderValue={false}
      styles={customStyles}
      placeholder={placeholder}
      isDisabled={selectedOptions?.length === options?.length}
      isOptionDisabled={(option: any) => option.disabled}
      value={selectedOptions}
      onChange={onChange}
      components={{
        DropdownIndicator,
        IndicatorSeparator,
        ClearIndicator,
        NoOptionsMessage,
        Option,
      }}
    />
  )
}

const Option = (props: OptionProps<FilterDropdownOption>) => {
  return (
    <components.Option {...props}>
      <div
        className={clsx(
          { ['text-gray-500 cursor-default']: props.data.disabled },
          'flex items-center',
        )}
      >
        <div className="flex-grow">{props.label}</div>
        {props.data.count >= 0 && (
          <div className="text-gray-500">{props.data.count}</div>
        )}
      </div>
    </components.Option>
  )
}
const IndicatorSeparator = (props: IndicatorSeparatorProps) => {
  return null
}

const ClearIndicator = (props: ClearIndicatorProps) => {
  return null
}

const NoOptionsMessage = () => {
  return null
}

const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <MdChevronRight
        className={clsx('rotate-90 transition-transform', {
          ['-rotate-90']: props.selectProps.menuIsOpen,
        })}
      />
    </components.DropdownIndicator>
  )
}

const customStyles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
  container: (provided) => ({
    ...provided,
    pointerEvents: 'auto',
    position: 'relative',
  }),
  control: (provided, { isDisabled }) => ({
    ...provided,
    opacity: 100,
    width: 'auto',
    // marginRight: '2rem',
    border: '0px',
    caretColor: 'transparent',
    fontSize: '0.8rem',
    minHeight: 'unset',
    boxShadow: 'none',
    background: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'transparent',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0px',
    cursor: 'pointer',
  }),
  indicatorsContainer: (provided, { isDisabled }) => ({
    ...provided,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    '> div': {
      padding: '0px',
    },
  }),
  input: (provided) => ({
    ...provided,
    padding: '0px',
    margin: '0px',
    cursor: 'pointer',
    '> input': {
      cursor: 'pointer',
    },
  }),
  placeholder: (provided, { isDisabled }) => ({
    ...provided,
    color: 'black',
    fontSize: '0.8rem',
    letterSpacing: '0.1rem',
    padding: '0px',
    margin: '0px',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '0px',
    margin: '0px',
    borderRadius: '0.125rem',
  }),
  menu: (provided) => ({
    ...provided,
    width: '14rem',
    position: 'absolute',
    left: '0px',
    marginTop: '0.25rem',
    zIndex: 10,
    borderRadius: '0.125rem',
    boxShadow:
      '0 0 0 0px #fff, 0 0 0 1px rgba(0,0,0,0.05), 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  }),
  option: (provided, state: any) => ({
    ...provided,
    color: 'rgb(55 65 81)',
    marginTop: '0px',
    padding: '0.5rem 1rem 0.5rem 1rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    letterSpacing: '0.1rem',
    fontWeight: 500,
    backgroundColor: '#fff',
    cursor: state.data.disabled ? 'default' : 'pointer',
    '&:hover': {
      backgroundColor: '#f8f7f7',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'black!important',
  }),
}

export default FilterDropdown
